export default __webpack_public_path__ + "static/media/profile-pc.e644a11c.webp";